import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Login from "./components/Login";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";
import Dashboard from "./pages/Dashboard";
import Insights from "./pages/Insights";
import ContextGraph from "./pages/ContextGraph";
import Fulfillment from "./pages/Fulfillment";
import Connectors from "./pages/Connectors";
import DecisionsToday from "./pages/vans/DecisionsToday";
import VansGraph from "./pages/vans/VansGraph";
import VansConnectors from "./pages/vans/VansConnectors";
import IGLDecisions from "./pages/igl/IGLDecisions";
import IGLGraph from "./pages/igl/IGLGraph";
import IGLConnectors from "./pages/igl/IGLConnectors";
import DalmiaDecisions from "./pages/dalmia/DalmiaDecisions";
import DalmiaDashboard from "./pages/dalmia/DalmiaDashboard";
import DalmiaGraph from "./pages/dalmia/DalmiaGraph";
import DalmiaFulfillment from "./pages/dalmia/DalmiaFulfillment";
import DalmiaConnectors from "./pages/dalmia/DalmiaConnectors";
import RVCommandCenter from "./pages/iglrv/RVCommandCenter";
import RVOperator from "./pages/iglrv/RVOperator";
import RVVehicle from "./pages/iglrv/RVVehicle";
import RVAnpr from "./pages/iglrv/RVAnpr";
import RVFleet from "./pages/iglrv/RVFleet";
import RVPrevalidate from "./pages/iglrv/RVPrevalidate";
import RVConnectors from "./pages/iglrv/RVConnectors";
import Admin from "./pages/Admin";

function AppRouter() {
  const location = useLocation(); // read hash from here (reactive), not window.location.hash
  const { user, loading } = useAuth();

  // Process OAuth return FIRST (synchronously during render) to avoid race conditions.
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  if (loading) {
    return (
      <div className="login-shell">
        <div className="login-card"><div className="login-brand">Dot<span>IQ</span></div><div className="cb-spinner" /></div>
      </div>
    );
  }

  if (!user) return <Login />;

  return (
    <Layout today={user ? undefined : ""}>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/graph" element={<ContextGraph />} />
        <Route path="/fulfillment" element={<Fulfillment />} />
        <Route path="/connectors" element={<Connectors />} />
        <Route path="/vans" element={<DecisionsToday />} />
        <Route path="/vans/graph" element={<VansGraph />} />
        <Route path="/vans/connectors" element={<VansConnectors />} />
        <Route path="/igl" element={<IGLDecisions />} />
        <Route path="/igl/graph" element={<IGLGraph />} />
        <Route path="/igl/connectors" element={<IGLConnectors />} />
        <Route path="/dalmia" element={<DalmiaDashboard />} />
        <Route path="/dalmia/insights" element={<DalmiaDecisions />} />
        <Route path="/dalmia/graph" element={<DalmiaGraph />} />
        <Route path="/dalmia/fulfillment" element={<DalmiaFulfillment />} />
        <Route path="/dalmia/connectors" element={<DalmiaConnectors />} />
        <Route path="/iglrv" element={<RVCommandCenter />} />
        <Route path="/iglrv/operator" element={<RVOperator />} />
        <Route path="/iglrv/vehicles/:plate" element={<RVVehicle />} />
        <Route path="/iglrv/anpr" element={<RVAnpr />} />
        <Route path="/iglrv/fleet" element={<RVFleet />} />
        <Route path="/iglrv/prevalidate" element={<RVPrevalidate />} />
        <Route path="/iglrv/connectors" element={<RVConnectors />} />
        {user.role === "admin" && <Route path="/admin" element={<Admin />} />}
      </Routes>
    </Layout>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
